define([
    "underscore",
    "backbone",
    "backbone.form"
], function(_, Backbone) {
    return Backbone.Form.extend({
        url: "/rest_deposit/validate_form/currency_market",

        validation: {
            code_section: {
                required: true,
                pattern: 'number'
            },
            usdt_ea: {
                required: true,
                pattern: 'number'
            },
            usdt_rate: {
                required: true,
                pattern: 'number'
            },
            withdraw_money: {
                required: true,
            },
            deposit_money: {
                required: true,
                pattern: 'number'
            },
            currency_abbr: {
                required: true,
            },
            bank_name: {
                required: true,
            },
            bank_depositor: {
                required: true,
            },
            bank_account: {
                required: true,
                pattern: 'number'
            },
            user_email: {
                required: true,
                pattern: 'email'
            },
            user_phone: {
                required: true,
                pattern: 'number'
            },
            user_ewallet: {
                required: true,
            },
        },

        labels:{
            deposit_money: "Deposit Money",
            currency_abbr: "Currency",
            mt4_account_no: "MT4 Account No.",
            bank_name: "Bank Name",
            bank_depositor: "Bank Depositor",
            bank_account: "Bank Account",
            user_email: "Email",
            user_phone: "User phone Number",
            user_ewallet: "User USDT Deposit Address"
        }
    });
});
